import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { MoreInfo } from 'components/icons';
import RecommendedSizeFinderModal from 'components/productdetail/stylepicker/RecommendedSizeFinderModal';
import RecommendedSizeTooltip from 'components/productdetail/stylepicker/RecommendedSizeTooltip';
import styles from 'styles/components/productdetail/recommendedSizing.scss';

// This component only shows up on desktop (see styles.recommendedFit)
export const RecommendedSizeInfo = () =>
  <div className={styles.recommendedFit}>
    <strong>Recommended Fit</strong>
    <MoreInfo/>
  </div>;

export const RecommendedSizeButton = props => {
  const { openModal, describedby } = props;
  return <button
    type="button"
    aria-describedby={describedby}
    className={styles.calculateSize}
    onClick={openModal}
  >
    Calculate Your Size!
  </button>;
};

export const RecommendedSizeIndicator = props => {
  const { predictedSize, selectedSize } = props;
  return <>
    <MoreInfo className={styles.sizeIndicatorIcon} />
    <span>{`Your recommended size is ${selectedSize === predictedSize ? 'selected' : predictedSize}`}</span>
  </>;
};

export const RecommendedSizing = props => {
  const {
    predictedSize,
    selectedSize,
    onOpenModal,
    onCloseModal,
    handleSetRecommendedFit,
    gender,
    product : { detail : { productId } },
    onDemandSize,
    handleCalculateSizeClick,
    isOnDemandSizingModalOpen,
    location
  } = props;

  const tooltipId = 'recommendedSizeTooltip';
  return (
    <div className={styles.recommendedFitContainer}>
      { predictedSize
        ? <RecommendedSizeIndicator selectedSize={selectedSize} predictedSize={predictedSize}/>
        : <>
            <RecommendedSizeInfo />
            <RecommendedSizeTooltip id={tooltipId} openModal={onOpenModal} />
            <RecommendedSizeButton describedby={tooltipId} openModal={onOpenModal} />
          </>
      }
      <RecommendedSizeFinderModal
        productId={productId}
        gender={gender}
        onSetRecommendedFit={handleSetRecommendedFit}
        onClose={onCloseModal}
        location={location}
        onDemandSize={onDemandSize}
        handleCalculateSizeClick={handleCalculateSizeClick}
        isOpen={isOnDemandSizingModalOpen}
        predictedSize={predictedSize}/>
    </div>
  );
};

RecommendedSizing.propTypes = {
  gender: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  onOpenModal : PropTypes.func.isRequired,
  onCloseModal : PropTypes.func.isRequired,
  handleSetRecommendedFit : PropTypes.func,
  predictedSize : PropTypes.string,
  selectedSize : PropTypes.string
};

export default connect(state => {
  const { product : { sizingPredictionValue }, sizingChooser: { sizingChooser : { recommendedFit } } } = state;
  return {
    predictedSize : recommendedFit || sizingPredictionValue || ''
  };
})(RecommendedSizing);
